exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active-tab[data-v-7dfab7a5]{background-color:#ece4df;color:#3c47d1!important;font-weight:700}", ""]);

// exports
